export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5197.de26e310.jpg";